import { TArrayQuestion } from "../../../interfaces/quiz";
import img1 from "../../../../img/gallery/historia_palacio/1.png";
import img2 from "../../../../img/quiz/img1.png";
import img3 from "../../../../img/quiz/img2.png";
import img4 from "../../../../img/quiz/img3.png";
import img5 from "../../../../img/quiz/img4.png";

const spQuestions:TArrayQuestion =[
    {
        theme:"Actividad parlamentaria",
        question:"La sesión legislativa tiene una duración de:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Cuatro años"
            },
            {
                ansCode:1,
                text:"Cinco años"
            },
            {
                ansCode:2,
                text:"Diez años"
            }
        ],
        correct:1
    },
    {
        theme:"Actividad parlamentaria",
        question:"Puedes asistir a las sesiones plenarias desde la Sala de Sesiones:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"cualquier ciudadano"
            },
            {
                ansCode:1,
                text:"Solo ciudadanos o personas invitadas"
            },
            {
                ansCode:2,
                text:"Solo periodistas y empleados parlamentarios"
            }
        ],
        correct:0
    },
    {
        theme:"Actividad parlamentaria",
        question:"El presidente de la Asamblea Nacional es elegido:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Por sufragio directo y universal en las elecciones legislativas"
            },
            {
                ansCode:1,
                text:"Por el tribunal constitucional"
            },
            {
                ansCode:2,
                text:"Por mayoría absoluta de votos de los Diputados en funciones efectivas"
            }
        ],
        correct:2
    },
    {
        theme:"Constitución",
        question:"La constitución actual fue aprobada en:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1990"
            },
            {
                ansCode:2,
                text:"1992"
            }
        ],
        correct:2
    },
    {
        theme:"Constitución",
        question:"La aprobación de dos mociones de censura al Gobierno, implica necesariamente:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"La celebración de elecciones anticipadas"
            },
            {
                ansCode:1,
                text:"La dimisión del gobierno"
            },
            {
                ansCode:2,
                text:"La presentación por parte del Gobierno de una moción de confianza"
            }
        ],
        correct:1
    },
    {
        theme:"Constitución",
        question:"¿A partir de qué edad puede un ciudadano postularse a la presidencia de la República?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"18 años"
            },
            {
                ansCode:1,
                text:"35 años"
            },
            {
                ansCode:2,
                text:"45 años"
            }
        ],
        correct:1
    },
    {
        theme:"História parlamentaria",
        question:"¿En qué año se celebraron las primeras elecciones multipartidistas en Cabo Verde?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1981"
            },
            {
                ansCode:2,
                text:"1991"
            }
        ],
        correct:2
    },
    {
        theme:"História parlamentaria",
        question:"¿Quién fue el primer presidente de la Asamblea de la República?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Abílio Duarte"
            },
            {
                ansCode:1,
                text:"Amilcar Spencer Lopes"
            },
            {
                ansCode:2,
                text:"Antonio do Espirito Santo Fonseca"
            }
        ],
        correct:0
    },
    {
        theme:"História parlamentaria",
        question:"¿Cuál fue la fecha de la inauguración del Palacio de la Asamblea Nacional?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"8 de octubre de 1988"
            },
            {
                ansCode:1,
                text:"18 de octubre de 1983"
            },
            {
                ansCode:2,
                text:"28 de octubre de 1985"
            }
        ],
        correct:2
    },
    {
        theme:"Parlamento en imágenes",
        question:"En 1975 se celebró en este edificio la primera sesión parlamentaria. ¿Puedes identificar el edificio?",
        image:{
            exist:true,
            src:img1
        },
        answer:[
            {
                ansCode:0,
                text:"Salón del Consejo - São Vicente"
            },
            {
                ansCode:1,
                text:"Salón del Consejo - Praia"
            },
            {
                ansCode:2,
                text:"Salón del Consejo - São Filipe"
            }
        ],
        correct:1
    },
    /*{
        theme:"Parlamento en imágenes",
        question:"¿Quién es el autor de la siguiente tabla, ofrecida al presidente de la Asamblea Nacional en 1998?",
        image:{
            exist:true,
            src:img2
        },
        answer:[
            {
                ansCode:0,
                text:"Bertina Lopes"
            },
            {
                ansCode:1,
                text:"Kiki Lima"
            },
            {
                ansCode:2,
                text:"Pedro Martins"
            }
        ],
        correct:0
    },*/
    {
        theme:"Parlamento en imágenes",
        question:"¿Cuál es el título de esta pintura realizada por varios artistas caboverdianos para conmemorar el 20 aniversario de la Independencia Nacional?",
        image:{
            exist:true,
            src:img3
        },
        answer:[
            {
                ansCode:0,
                text:"La mezcla criolla"
            },
            {
                ansCode:1,
                text:"Todos los días caboverdiano"
            },
            {
                ansCode:2,
                text:"La aventura criolla"
            }
        ],
        correct:2
    },
    {
        theme:"Constitución",
        question:"La Asamblea Nacional de Cabo Verde es el segundo órgano de soberanía nacional, es responsable de las funciones",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Supervisión legislativa y política"
            },
            {
                ansCode:1,
                text:"Vetar o promulgar leyes"
            },
            {
                ansCode:2,
                text:"Ejecutivo"
            }
        ],
        correct:0
    },
    {
        theme:"Símbolos nacionales",
        question:"El himno caboverdiano actual fue escrito por",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Norberto Tavares"
            },
            {
                ansCode:1,
                text:"Amílcar Spencer Lopes "
            },
            {
                ansCode:2,
                text:"Abílio Duarte"
            }
        ],
        correct:1
    },
    {
        theme:"Parlamento en imágenes",
        question:"¿Cómo se llama la figura del folclore caboverdiano representada en esta pieza?",
        image:{
            exist:true,
            src:img4
        },
        answer:[
            {
                ansCode:0,
                text:"Chibinho"
            },
            {
                ansCode:1,
                text:"Tia Ganga"
            },
            {
                ansCode:2,
                text:"Blimundo"
            }
        ],
        correct:2
    },
    {
        theme:"Parlamento en imágenes",
        question:"¿Este monumento representa la amistad de Cabo Verde con qué país?",
        image:{
            exist:true,
            src:img5
        },
        answer:[
            {
                ansCode:0,
                text:"Brasil"
            },
            {
                ansCode:1,
                text:"China"
            },
            {
                ansCode:2,
                text:"Portugal"
            }
        ],
        correct:1
    },
    {
        theme:"Actividad parlamentaria",
        question:"Cada Sesión Legislativa se cierra con un debate sobre un tema muy conocido, ¿qué es?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"estado de la nación"
            },
            {
                ansCode:1,
                text:"Presupuesto del Estado"
            },
            {
                ansCode:2,
                text:"Estado de justicia"
            }
        ],
        correct:0
    },
    {
        theme:"Constitución",
        question:"Según el Reglamento, ¿cuántas sesiones ordinarias se celebran cada mes?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Un"
            },
            {
                ansCode:1,
                text:"Dos"
            },
            {
                ansCode:2,
                text:"Tres"
            }
        ],
        correct:1
    }
];

export default spQuestions;